module.exports = __webpack_public_path__ + "static/media/inN2.35ed7a56.png";